import Vue from 'vue'
import Router from 'vue-router'
import product from '@/pages/product'
import home from '@/pages/home'
import service from '@/pages/service'
import cooperation from '@/pages/cooperation'
import knowUs from '@/pages/knowUs'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation
    },
    {
      path: '/knowUs',
      name: 'knowUs',
      component: knowUs
    },
    {
      path: '/linkUs',
      name: 'linkUs',
      component: service
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js